import ValueObject from './ValueObject';

export default class CustomLabel extends ValueObject {
  equals(other) {
    if (!(other instanceof CustomLabel)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new CustomLabel(json);
  }
}
